import { post } from '../../api'
import { SimpleApi } from '../../api-action'
import { Transform } from '../../types/core'
import { SignupParams } from './types'

export const signupApi: Transform<string, Transform<SignupParams, SimpleApi>> = url => params => post(url, params)
